<template>
  <v-dialog v-model="showDialog" width="500">
    <v-card v-if="customerContractId">
      <v-card-title class="secondary white--text px-4 py-2">
        Tariff Id -
        {{ customerContractDetails.contract_id }}
        <v-spacer></v-spacer>

        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="white"
              icon
              @click="showDialog = false"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon class="white--text">mdi-close</v-icon>
            </v-btn>
          </template>
          <span>Close</span>
        </v-tooltip>
      </v-card-title>

      <v-card-text>
        <table class="Normal-Table my-2">
          <tbody>
            <tr>
              <td>Customer Name</td>
              <th class="px-2">:</th>
              <th>
                {{ customerContractDetails.customer_name }}
              </th>
            </tr>

            <tr>
              <td>Start Date</td>
              <th class="px-2">:</th>
              <th>
                {{ customerContractDetails.start_date | formatDate }}
              </th>
            </tr>

            <tr>
              <td>End Date</td>
              <th class="px-2">:</th>
              <th>
                {{ customerContractDetails.end_date | formatDate }}
              </th>
            </tr>
          </tbody>
        </table>

        <v-divider></v-divider>

        <table class="Full-Width">
          <tbody>
            <tr>
              <td>
                <div class="my-2">
                  <span>Remarks</span>
                  <p class="font-weight-bold mb-0">
                    {{ customerContractDetails.admin_remarks }}
                  </p>
                </div>
              </td>
            </tr>

            <tr>
              <td>
                <v-divider></v-divider>
                <table class="Full-Width text-left mt-2">
                  <thead>
                    <tr>
                      <th>Route</th>
                      <th>Job Type</th>
                      <th>Container Type</th>
                      <th class="text-right">Count</th>
                      <th class="text-right">
                        Rate ({{ $globals.currency }})
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(rate, i) in customerContractV2Rates"
                      :key="i"
                    >
                      <td>{{ rate.lane_title }}</td>
                      <td>{{ rate.job_type }}</td>
                      <td>{{ rate.container_type_title }}</td>
                      <td class="text-right">
                        {{ rate.container_count }}
                      </td>
                      <td class="text-right">{{ rate.rate }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
    },
    customerContractId: {
      type: [Object, Number],
      default: () => {},
    },
  },
  data() {
    return {
      customerContractDetails: {},
      customerContractV2Rates: [],
    };
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(val) {
      if (val && this.customerContractId) {
        this.getCustomerContractV2Object(this.customerContractId);
        this.getCustomerContractV2Rates(this.customerContractId);
      }
    },
  },

  methods: {
    getCustomerContractV2Object(id) {
      this.$bus.$emit("showLoader", true);
      this.$api.customerContractV2
        .getCustomerContractV2Object(id)
        .then((res) => {
          this.customerContractDetails = res.data;
          this.$bus.$emit("showLoader", false);
        })
        .catch((err) => {
          console.error(err);
          this.$bus.$emit("showLoader", false);
        });
    },
    getCustomerContractV2Rates(id) {
      this.$api.customerContractV2
        .getCustomerContractV2RateList({
          customer_contract_v2: id,
          limit: "all",
        })
        .then((res) => {
          this.customerContractV2Rates = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
};
</script>
